const graphColors = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

export default graphColors;